import { render, staticRenderFns } from "./BalanceRow.vue?vue&type=template&id=3bc8e0d2&scoped=true&"
import script from "./BalanceRow.vue?vue&type=script&lang=ts&"
export * from "./BalanceRow.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceRow.vue?vue&type=style&index=0&id=3bc8e0d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc8e0d2",
  null
  
)

export default component.exports